import React from "react";
import {Select} from "@appkit4/react-components/select"
import NewDateString from '../../../Common/newDateString.js'
import PropTypes from 'prop-types';

function AssessmentRequirements(props) {
  const getStandardDate = (date) => {
    let newDate = new Date(date);
    let isoDate = newDate.toISOString();
    let requiredDate = isoDate.split("T")[0];
    return requiredDate;
  };
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    getAssessment,
  } = props;
  
  return (
    <div>
      <div className="row m-0">
        <div className="col-sm-6">
          <div className="cv-input-field-container">
            <label className="cv-input-label">
              Assessment Type<span className="asterisk-required">*</span>
            </label>

            <Select
              showSearchOnToggle={true}
              dropdownRenderMode="portal"
              searchable={true}
              className="cv-input-field"
              type="email"
              data={props.assessmentTypes}
              valueKey="assessmenttype_id"
              labelKey="assessment_type"
              value={values.assessment}
              onSelect={(e) => { handleChange("assessment")({ target: { value: e } }); getAssessment(e) }}
              name="assessment"
              placeholder="Select Assessment"
            >
            </Select>
          </div>
          {errors.assessment && touched.assessment && (
            <div className="form-label error">{errors.assessment}</div>
          )}
        </div>
        <div className="col-sm-6">
          <div className="cv-input-field-container">
            <label className="cv-input-label">
              Frequency
            </label>
            <Select
              showSearchOnToggle={true}
              dropdownRenderMode="portal"
              searchable={true}
              className="cv-input-field"
              type="email"
              data={props.frequency}
              labelKey="frequency"
              valueKey="frequency_id"
              value={values.frequency}
              onSelect={(e) =>
                handleChange("frequency")({ target: { value: e } })
              }
              name="frequency"
              placeholder="Select frequency"
            >
            </Select>
          </div>
          
        </div>
      </div>
      <div className="row m-0">
        <div className="col-sm-6">
          <div className="cv-input-field-container">
            <label className="cv-input-label">
              Recurrence(s) 
            </label>
            <Select
              showSearchOnToggle={true}
              dropdownRenderMode="portal"
              searchable={true}
              className="cv-input-field"
              type="number"
              data={props.recurrence}
              valueKey="recurrence_id"
              labelKey="recurrence"
              value={values.recurrence}
              onSelect={(e) =>
                handleChange("recurrence")({ target: { value: e } })
              }
              name="recurrence"
              placeholder="Select Recurrence"
            >
            </Select>
          </div>
          
        </div>
        <div className="col-sm-6">
          <div className="cv-input-field-container">
            <label htmlFor="EndAfterRequirements" className="cv-input-label">
              End After
            </label>
            <input
              id="EndAfterRequirements"
              className="cv-input-field p-l-2"
              onBlur={handleBlur}
              type="date"
              value={
                values.endAfter
                  ? getStandardDate(values.endAfter)
                  : values.endAfter
              }
              onChange={handleChange("endAfter")}
              name="endAfter"
              min={NewDateString()}
            />
          </div>
         
        </div>
        <div className="col-sm-6">
          <div className="cv-input-field-container">
            <label htmlFor="RegulatoryRequirements" className="cv-input-label">
              Regulatory/ Standard Requirements<span className="asterisk-required">*</span>
            </label>
            <input
              id="RegulatoryRequirements"
              className="cv-input-field leftPadding"
              onBlur={handleBlur}
              type="input"
              value={values.regulatory}
              onChange={handleChange("regulatory")}
              name="regulatory"
              placeholder={"Please enter Regulatory/ Standard Requirements"}
            />
          </div>
          {errors.regulatory && touched.regulatory && (
            <div className="form-label error">{errors.regulatory}</div>
          )}
        </div>
      </div>
    </div>
  );
}
AssessmentRequirements.propTypes = {
  values: PropTypes.object,
  touched:PropTypes.object,
  errors:PropTypes.object,
  handleChange:PropTypes.func,
  handleBlur:PropTypes.func,
  getAssessment:PropTypes.func,
  assessmentTypes:PropTypes.array,
  recurrence:PropTypes.array,
  frequency:PropTypes.array
}
export default AssessmentRequirements;
